(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
		popupSliderInit(true);
	}

	document.addEventListener('shopify:section:load', function (e) {
		swiperInit();
	});

	swiperInit();
})();


document.addEventListener("DOMContentLoaded", () => {
  // Собираем все JSON-галереи по вариантам
  const galleries = {};
  document.querySelectorAll("script[data-variant-gallery]").forEach(script => {
    const variantId = script.getAttribute("data-variant-gallery");
    try {
      galleries[variantId] = JSON.parse(script.textContent);
    } catch (e) {
      console.error("Ошибка парсинга JSON для варианта", variantId, e);
    }
  });

  // Основной слайдер
  const swiperEl = document.querySelector(".product__media-list.swiper");
  if (!swiperEl) return;

  let swiper = swiperEl.swiper;

  // Базовая (стандартная) галерея — берём все медиа из Liquid
  const defaultSlides = Array.from(
    swiperEl.querySelectorAll(".swiper-slide")
  ).map(slide => slide.outerHTML);

  /**
   * Функция обновления слайдов
   */
  function updateGallery(variant) {
    const gallery = galleries[variant.id];

    // Если у варианта есть кастомная галерея → показываем её
    if (gallery && Array.isArray(gallery) && gallery.length > 0) {
      swiper.removeAllSlides();

      const newSlides = gallery.map((img, i) => {
        const url = `${img.src}&width=1600`;
        const loading = i === 0 ? "eager" : "lazy";
        return `
          <div class="product__media-item swiper-slide">
            <img 
              src="${url}" 
              alt="${variant.title}" 
              loading="${loading}" 
              class="img-responsive"
            />
          </div>
        `;
      });

      swiper.appendSlide(newSlides);
      swiper.update();
      swiper.slideTo(0, 0);
    } else {
      // иначе показываем дефолтную галерею
      swiper.removeAllSlides();
      swiper.appendSlide(defaultSlides);
      swiper.update();
      swiper.slideTo(0, 0);
    }
  }

  /**
   * Ловим смену варианта
   */
  document.addEventListener("variant:change", e => {
    const variant = e.detail.variant;
    if (!variant || !variant.id) return;

    updateGallery(variant);
  });
});



